import { render } from "./subMenuMais.vue?vue&type=template&id=360d74e9"
import script from "./subMenuMais.vue?vue&type=script&lang=js"
export * from "./subMenuMais.vue?vue&type=script&lang=js"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__